import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import "../../../investor/investor.css";
import { getTaxEntitiesByContactAction } from "../../../actions/contactsAction";
import { getTaxEntityDetailAction, getTaxEntityListAction } from "../../../actions/investorAccounts";
import { getTaxEntityContactsAction, getContactRoleAction, getContactRoleAccessAction } from "../../../actions/taxDetailsAction";
import { AgGridReact } from "ag-grid-react";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { SBADropDown, SBAComboBox } from "../../../UiComponents/SBADropDown";
import moment from "moment";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { AccountDetails } from "../../investorAccounts/InvestorAccountDetails";
import { deleteTaxEntityContact, insertOrUpdatetaxEntityContact, getActivityEntity, getContactRoleDefaultAccess, deleteTaxEntityAPI, checkTaxEntityRole } from "../../../../config/apiConfig";
import { Modal } from "react-bootstrap";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";

export const Account = (props) => {
    const locationData = useLocation();
    const dispatch = useDispatch();
    const params = useParams();
    const Gstate = useSelector((state) => state) || {};
    const isEditable = Gstate.authorizationData.isEditable;
    const TaxEntitiesByContact = Gstate?.Contacts.TaxEntities || [];
    const taxEntityId = TaxEntitiesByContact[0]?.TaxEntityId;
    const [showDetails, setShowDetails] = useState(false);
    const istaxEntityDetailsLoading = Gstate.investorAccounts?.isTaxEntityDetailLoading;
    const taxEntityDetails = Gstate.investorAccounts?.taxEntityDetail;
    const taxEntityListLoading = Gstate?.investorAccounts?.isTaxEntityListLoading;
    const taxEntityContacts = Gstate.TaxEntityContacts?.TaxEntityContacts;
    const Getcontactroles = Gstate.ContactRole?.ContactRole;
    const taxEntityContactsdefault = Gstate.TaxEntityContacts?.TaxEntityContacts[0];
    const accountList = Gstate.investorAccounts.taxEntityList || [];

    const TaxContactAccessedata = Gstate.TaxEntityContactAccess?.TaxEntityContactAccess.TaxEntityContactAccesses;
    // edit grid access data
    const contactdefaultaccess = Gstate.ContactRoleDefaccess?.ContactRoleDefaccess;
    const [showDrawer, setshowDrawer] = useState(false);
    const [showEdit, setshowEdit] = useState(false);
    const [Role, setRole] = useState([]);
    const [mode, setmode] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [delcontactid, setdelcontactid] = useState([]);
    const [ContactName, setContactName] = useState([]);
    const [ContactId, setContactId] = useState([]);
    const [RoleId, setRoleId] = useState([]);
    const [Contactlist, setContactlist] = useState([]);
    const [saveEntityId, setsaveEntityId] = useState([]);
    const [Accesslist, setAccesslist] = useState([]);
    const [defAccesslist, setdefAccesslist] = useState([]);
    const [NewContact, setNewContact] = useState([]);
    const [NewAccount, setNewAccount] = useState([]);
    const [deleteAccount,setDeleteAccount]=useState({taxEntityID:0,contactID:0,DeleteModal:false});
    const [contactTaxEntRoleXRefId,setContactTaxEntRoleXRefId]=useState(0);

  useEffect(() => {
      document.title = `Investor Details`;
      dispatch(getTaxEntitiesByContactAction(params.ContactId));
      dispatch(getTaxEntityListAction());
      dispatch(getContactRoleAction());
      getEntities();
    
      
  }, []);

    useEffect(() => {
        dispatch(getTaxEntityDetailAction(taxEntityId));
        dispatch(getTaxEntityContactsAction(taxEntityId));
        setsaveEntityId(taxEntityId);
       // dispatch(getTaxEntityContactAccessAction(taxEntityId, params.ContactId));
    }, [taxEntityId]);

    useEffect(() => {
        if (TaxContactAccessedata) {
            setAccesslist(TaxContactAccessedata?.map(item => (
                { ...item, addMenu: false }
            )))
        }

        if (TaxContactAccessedata) {
            setdefAccesslist(TaxContactAccessedata?.map(item => (
                { ...item, Editlist: item.IsChecked }
            )))
        }

    }, [TaxContactAccessedata, contactdefaultaccess]);

    const taxEntityRef = useRef();
    const TaxContactAccesseRef = useRef();
    const getEntities = async () => {
        try {

            const response = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${0}&SearchString=${null}&activitySourceId=2`,
                method: 'get',
            });
            const data = response;
            setContactlist(data);
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    const checkIfCanAddRole = async (contactId, taxEntityId, roleId) => {
        try {
            const response = await sbaAxios({
                url: `${checkTaxEntityRole}${contactId},${taxEntityId},${roleId}`,
                method: 'get',
            });
           
            return response
        } catch (error) {
            console.error('Error checking role:', error);
            return false;
        }
    }

    const closeModal = () => {
        setshowDrawer(false);
        setShowModal(false);
        setshowEdit(false);
    };
    const onAddButtonClick = (data) => {
       
        const values = data;
        setRole([]);
        setmode(values);
        setshowDrawer(true);
        setNewContact([]);
        setNewAccount();
        if (TaxContactAccessedata) {
            setAccesslist(TaxContactAccessedata?.map(item => (
                { ...item, addMenu: false }
            )))
        }

    };
    const EditButtonRenderer = (props) => {
        const Editdata = props.data;
        const contactId = props.data.ContactId;
       const contactTaxEntRoleXRefId=props.data.ContactTaxEntRoleXRefId;
        const handleDeleteClick = () => {
            if (props.data.ContactRoleId !== 24 && isEditable !== false ) {
                setdelcontactid(contactId)
                setContactTaxEntRoleXRefId(contactTaxEntRoleXRefId);
                setShowModal(true);
            }

        }

        const handleEditClick = () => {
            if (isEditable !== false ) {
               // dispatch(getTaxEntityContactAccessAction(saveEntityId, Editdata.ContactId));
                setContactName({ "ContactName": Editdata.ContactName, "ContactId": Editdata.ContactId })
                setRole({ "ContactRoleName": Editdata.ContactRoleName, "ContactRoleId": Editdata.ContactRoleId });
                setContactId(Editdata.ContactId)
                setRoleId(Editdata.ContactRoleId);
                setContactTaxEntRoleXRefId(Editdata.ContactTaxEntRoleXRefId);
                setshowEdit(true);
            }
        };
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-edit"
                    style={{ color: isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
                <i disabled={props.data.ContactRoleId === 24}
                    className="fas fa-trash"
                    style={{ color: props.data.ContactRoleId === 24 || isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: props.data.ContactRoleId !== 24 && "pointer" }}
                    onClick={() => { handleDeleteClick(props.data.ContactRoleId) }}
                ></i>
            </div>
        );

    }

    const onDeleteButtonClick = () => {
        const delid = saveEntityId.length !== 0 ? saveEntityId : taxEntityId;
        sbaAxios({
            url: `${deleteTaxEntityContact}${contactTaxEntRoleXRefId}`,
            method: 'get',
        }).then(() => {
            setShowModal(false);
            SBNotify({ Msg: "Selected contact Deleted Successfully", type: "success" });
            dispatch(getTaxEntityContactsAction(delid));
            dispatch(getTaxEntitiesByContactAction(params.ContactId));
        }).catch(() => {
            SBNotify({ Msg: "some error  occured", type: "error" });
        })

    };
    const handleDeleteClick = (e) => {
        const taxEntityId = e.data.TaxEntityId;
        const ContactId = parseInt(e.data.ContactId);
        // setDeleteAccount(value=>({contactID:ContactId,taxEntityID:taxEntityId,DeleteModal:true}));  
    };
    const MainDeleteButtonRenderer = (props) => {



        const handleEditClick = () => {


        }
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={() => { handleDeleteClick(props) }}
                ></i>
                {/* <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i> */}
            </div>
        );
    };
    const AddCheckboxRenderer = (props) => {

        const ischeck = props.data.addMenu
        const contactdata = props.data;
        return (
            <div className="actions-cell">
                <input type='checkbox' className="SBA_hand" checked={ischeck} onChange={(e) => {
                    setAccesslist(value => (value.map(item => {
                        if (item.ContactAccessId === contactdata.ContactAccessId) {
                            return { ...item, 'addMenu': e.target.checked }
                        }
                        else {
                            return { ...item }
                        }
                    }
                    )))
                }} />
            </div>
        );
    }
    const EditCheckboxRenderer = (props) => {

        const ischeck = props.data.Editlist
        const contactdata = props.data;
        return (
            <div className="actions-cell">
                <input type='checkbox' className="SBA_hand" checked={ischeck} onChange={(e) => {

                    setdefAccesslist(value => (value.map(item => {
                        if (item.ContactAccessId === contactdata.ContactAccessId) {
                            return { ...item, 'Editlist': e.target.checked }
                        }
                        else {
                            return { ...item }
                        }
                    }
                    )))
                }} />
            </div>
        );
    }
    const taxEntityGridClick = (e) => {
        const taxEntityId = e?.data?.TaxEntityId;
        setsaveEntityId(taxEntityId);
        if (taxEntityId) {
            setShowDetails(true);
            dispatch(getTaxEntityDetailAction(taxEntityId));
            dispatch(getTaxEntityContactsAction(taxEntityId));

        }
    }
    //column defs
    const ContactColumnDef = [
        {
            headerName: "Account Name", field: "TaxEntityName",
        },


        {
            headerName: "Abbreviation", field: "TaxEntityAbbrev"
        },

        {
            headerName: "Registered State", field: "RegisteredState"
        },


        {
            headerName: "Status", field: "TaxEntityStatusName"


        },
        {
            headerName: "Inception Date", field: "InceptionDate",
            valueFormatter: function (params) {

                if (params.value && params.value !== '0001-01-01T00:00:00') {

                    const formattedDate = new Date(params.value).toLocaleDateString();
                    return formattedDate;
                } else {

                    return '';
                }

                        
              
            }
        },
        // {
        //     headerName: 'Action',
        //     field: 'Action',
        //     cellRenderer: MainDeleteButtonRenderer,
        //     hide:true
        // },
    ];

    const TaxContactdefdataDef = [

        {
            headerName: '',
            field: 'addMenu',
            cellRenderer: AddCheckboxRenderer,
            maxWidth: 80
        },
        {
            headerName: "Criteria Name", field: "ContactAccessName"
        },

    ];

    const EditTaxContactdefdataDef = [

        {
            headerName: '',
            field: 'Editlist',
            cellRenderer: EditCheckboxRenderer,
            maxWidth: 80
        },
        {
            headerName: "Criteria Name", field: "ContactAccessName"
        },

    ];

    const ContactEntityDef = [

        {
            headerName: "Contact Name", field: "ContactName", tooltipValueGetter: function (params) {
                return params.data.ContactName;
            },
        },
        {
            headerName: "Role Name", field: "ContactRoleName"
        },
        {
            headerName: "Action",
            field: "Action",

            cellRenderer: EditButtonRenderer, maxWidth: 100
        },

    ];

    const defaultColDef = {
        sortable: false,
        filter: false,
        suppressMovable: true,
        flex: 1,
        resizable:true
    };




    const Rolechange = async (e) => {
        try {
            setRole(e.value);

            // const response = await sbaAxios({
            //     url: `${getContactRoleDefaultAccess}${e.value.ContactRoleId}`,
            //     method: 'get',
            // });

            // const data = response;

            // setdefAccesslist(data?.map(item => (
            //     { ...item, Editlist: item.IsChecked }
            // )));

            // setAccesslist(data?.map(item => (
            //     { ...item, addMenu: item.IsChecked }
            // )))

        } catch (error) {
            console.error("Error fetching data:", error);

        }
    }



    const Contactonchange = (e) => {
        setNewContact(e.value);
    }
    const Accountonchange = (e) => {
        setNewAccount(e.value);
    }
    //const savecontact = async (data) => {
    //    let value = data;
    //    let ifsave = true;

    //     Check if role can be added
    //    const canAddRole = await checkIfCanAddRole(
    //        value === "Add" ? NewContact.EntityId : ContactId,
    //        saveEntityId.length !== 0 ? saveEntityId : taxEntityId,
    //        Role.ContactRoleId
    //    );

    //     If the API response is false, show an error and abort the save operation
    //    if (!canAddRole) {
    //        SBNotify({ Msg: "Cannot add this role. Please choose another.", type: "error" });
    //        return; // Exit the function early if the role cannot be added
    //    }

    //    const isAddCriteriaChecked = Accesslist.find(item => item.addMenu);
    //    const isEditCriteriaChecked = defAccesslist.find(item => item.Editlist);

    //    const AddtaxEntityContactAccess = Accesslist?.map(item => ({
    //        "contactAccessId": item.ContactAccessId,
    //        "isChecked": item.addMenu
    //    }));

    //    const EdittaxEntityContactAccess = defAccesslist?.map(item => ({
    //        "contactAccessId": item.ContactAccessId,
    //        "isChecked": item.Editlist
    //    }));

    //    const taxEntityContactRoleParams = {
    //        "contactId": value === "Add" ? NewContact.EntityId : ContactId,
    //        "taxEntityId": saveEntityId.length !== 0 ? saveEntityId : taxEntityId,
    //        "contactRoleId": Role.ContactRoleId,
    //        "modifiedBy": 0
    //    };

    //    const savedata = {
    //        "taxEntityContactRoleParams": taxEntityContactRoleParams,
    //        "taxEntityContactAccessParams": value === "Add" ? AddtaxEntityContactAccess : EdittaxEntityContactAccess
    //    };

    //     Validation logic remains the same...
    //    if (value === "Add") {
    //        if (!NewContact.EntityName || NewContact.EntityName === "") {
    //            ifsave = false;
    //            SBNotify({ Msg: "Please choose Contact", type: "error" });
    //        } else if (!NewContact.EntityId || NewContact.EntityId === 0 || NewContact.EntityId === "") {
    //            ifsave = false;
    //            SBNotify({ Msg: "Please choose Contact", type: "error" });
    //        }
    //        if (!isAddCriteriaChecked) {
    //            ifsave = false;
    //            SBNotify({ Msg: "Please Select any one Criteria", type: "error" });
    //        }
    //    }

    //    if (value === "Edit") {
    //        if (!isEditCriteriaChecked) {
    //            ifsave = false;
    //            SBNotify({ Msg: "Please Select any one Criteria", type: "error" });
    //        }
    //    }

    //    if (!Role.ContactRoleId || Role.ContactRoleId === 0 || Role.ContactRoleId === "") {
    //        ifsave = false;
    //        SBNotify({ Msg: "Please choose Role", type: "error" });
    //    }

    //    if (ifsave) {
    //        sbaAxios({
    //            url: `${insertOrUpdatetaxEntityContact}`,
    //            method: "post",
    //            data: savedata,
    //        }).then((response) => {
    //            closeModal();
    //            SBNotify({ Msg: "Contact Update Successfully", type: "success" });
    //            dispatch(getTaxEntityContactsAction(taxEntityContactRoleParams.taxEntityId));
    //            if (value === "Add") {
    //                if (TaxContactAccessedata) {
    //                    setAccesslist(TaxContactAccessedata?.map(item => (
    //                        { ...item, addMenu: false }
    //                    )))
    //                }
    //            }
    //        }).catch((error) => {
    //            SBNotify({ Msg: "Some error occurred", type: "error" });
    //        });
    //    }
    //}

    //const saveAccount = async () => {
    //    let ifsave = true;

    //     Check if role can be added
    //    const canAddRole = await checkIfCanAddRole(params.ContactId, NewAccount?.TaxEntityId, Role.ContactRoleId);

    //     If the API response is false, show an error and abort the save operation
    //    if (!canAddRole) {
    //        SBNotify({ Msg: "Cannot add this role. Please choose another.", type: "error" });
    //        return; // Exit the function early if the role cannot be added
    //    }

    //    const isAddCriteriaChecked = Accesslist.find(item => item.addMenu);

    //    const AddtaxEntityContactAccess = Accesslist?.map(item => ({
    //        "contactAccessId": item.ContactAccessId,
    //        "isChecked": item.addMenu
    //    }));

    //    const taxEntityContactRoleParams = {
    //        "contactId": params.ContactId,
    //        "taxEntityId": NewAccount?.TaxEntityId,
    //        "contactRoleId": Role.ContactRoleId,
    //        "modifiedBy": 0
    //    };

    //    const savedata = {
    //        "taxEntityContactRoleParams": taxEntityContactRoleParams,
    //        "taxEntityContactAccessParams": AddtaxEntityContactAccess
    //    };

    //    if (!NewAccount.TaxEntityId || NewAccount.TaxEntityId === 0 || NewAccount.TaxEntityId === "") {
    //        SBNotify({ Msg: "Please choose Account", type: "error" });
    //        ifsave = false;
    //    }

    //    if (!isAddCriteriaChecked) {
    //        ifsave = false;
    //        SBNotify({ Msg: "Please Select any one Criteria", type: "error" });
    //    }

    //    if (!Role.ContactRoleId || Role.ContactRoleId === 0 || Role.ContactRoleId === "") {
    //        ifsave = false;
    //        SBNotify({ Msg: "Please choose Role", type: "error" });
    //    }

    //    if (ifsave) {
    //        sbaAxios({
    //            url: `${insertOrUpdatetaxEntityContact}`,
    //            method: "post",
    //            data: savedata,
    //        }).then((response) => {
    //            closeModal();
    //            SBNotify({ Msg: "Account Update Successfully", type: "success" });
    //            dispatch(getTaxEntitiesByContactAction(params.ContactId));
    //        }).catch((error) => {
    //            SBNotify({ Msg: "Some error occurred", type: "error" });
    //        });
    //    }
    //}

    const savecontact = async (data) => {
        let value = data;
        let ifsave = true;
            //  Check if role can be added
        const canAddRole = await checkIfCanAddRole(NewContact.EntityId, saveEntityId, Role.ContactRoleId);
        if (canAddRole == false) {
            SBNotify({ Msg: "Selected role already exists for this Account/Contact.", type: "error" });
            return; // Exit the function early if the role cannot be added
        }
        const isAddCriteriaChecked = Accesslist.find(item => item.addMenu);
        const isEditCriteriaChecked = defAccesslist.find(item => item.Editlist);

        const AddtaxEntityContactAccess = Accesslist?.map(item => ({
            "contactAccessId": item.ContactAccessId,
            "isChecked": item.addMenu
        }));

        const EdittaxEntityContactAccess = defAccesslist?.map(item => ({
            "contactAccessId": item.ContactAccessId,
            "isChecked": item.Editlist
        }));
        const savedata = {
            "contactId": value === "Add" ? NewContact.EntityId : ContactId,
            "taxEntityId": saveEntityId.length !== 0 ? saveEntityId : taxEntityId,
            "contactRoleId": Role.ContactRoleId,
            "modifiedBy": 0,
            "ContactTaxEntRoleXRefId":value === "Add" ? 0 :contactTaxEntRoleXRefId
        };
        if (value === "Add") {
            if (!NewContact.EntityName || NewContact.EntityName === "") {
                ifsave = false;
                SBNotify({ Msg: "Please choose Contact", type: "error" });
            } else if (!NewContact.EntityId || NewContact.EntityId === 0 || NewContact.EntityId === "") {
                ifsave = false;
                SBNotify({ Msg: "Please choose Contact", type: "error" });
            }
            // if (!isAddCriteriaChecked) {
            //     ifsave = false;
            //     SBNotify({ Msg: "Please Select any one Criteria", type: "error" });
            // }
        }
        if (value === "Edit") {
            // if (!isEditCriteriaChecked) {
            //     ifsave = false;
            //     SBNotify({ Msg: "Please Select any one Criteria", type: "error" });
            // }
        }

        if (!Role.ContactRoleId || Role.ContactRoleId === 0 || Role.ContactRoleId === "") {
            ifsave = false;
            SBNotify({ Msg: "Please choose Role", type: "error" });
        }
        if (!Role.ContactRoleId || Role.ContactRoleId === 0 || Role.ContactRoleId === "") {
            ifsave = false;
            SBNotify({ Msg: "Please choose Role", type: "error" });
        }

        if (ifsave) {
            sbaAxios({
                url: `${insertOrUpdatetaxEntityContact}`,
                method: "post",
                data: savedata,
            }).then((response) => {
                closeModal();
                SBNotify({ Msg: "Contact Update Successfully", type: "success" });
                dispatch(getTaxEntityContactsAction( saveEntityId.length !== 0 ? saveEntityId : taxEntityId));
                if (value === "Add") {
                    if (TaxContactAccessedata) {
                        setAccesslist(TaxContactAccessedata?.map(item => (
                            { ...item, addMenu: false }
                        )))
                    }
                }

            }).catch((error) => {
                SBNotify({ Msg: "sone error  occured", type: "error" });
            });
        }


    }
    const saveAccount = async () => {
       
        let ifsave = true;
        //  Check if role can be added
        const canAddRole = await checkIfCanAddRole(params.ContactId, NewAccount.TaxEntityId, Role.ContactRoleId);

       
        const isAddCriteriaChecked = Accesslist.find(item=>item.addMenu);

         const AddtaxEntityContactAccess = Accesslist?.map(item => ({
                "contactAccessId": item.ContactAccessId,
                "isChecked": item.addMenu
         }));
     
        const taxEntityContactRoleParams = {
            "contactId": params.ContactId,
            "taxEntityId": NewAccount?.TaxEntityId ,
            "contactRoleId": Role.ContactRoleId,
            "modifiedBy": 0,
            "ContactTaxEntRoleXRefId":0
        };
        const savedata = {
            "contactId": params.ContactId,
            "taxEntityId": NewAccount?.TaxEntityId ,
            "contactRoleId": Role.ContactRoleId,
            "modifiedBy": 0,
            "ContactTaxEntRoleXRefId":0
        };
             if (!NewAccount?.TaxEntityId || NewAccount?.TaxEntityId === 0 || NewAccount?.TaxEntityId === "") {
                SBNotify({ Msg: "Please choose Account", type: "error" });
                ifsave = false;
                return;
            }
            // if(!isAddCriteriaChecked)
            // {
            //     ifsave = false;
            //     SBNotify({ Msg: "Please Select any one Criteria", type: "error" });
            // }       
       
        if (!Role.ContactRoleId || Role.ContactRoleId === 0 || Role.ContactRoleId === "")
        {
                ifsave = false;
                SBNotify({ Msg: "Please choose Role", type: "error" });
                return;

        }
        if (!canAddRole) {
            SBNotify({ Msg: "Cannot add this role. Please choose another.", type: "error" });
            return; 
        }
        if (ifsave) {
            sbaAxios({
                url: `${insertOrUpdatetaxEntityContact}`,
                method: "post",
                data: savedata,
            }).then((response) => {
                closeModal();
                SBNotify({ Msg: "Account Update Successfully", type: "success" });
                dispatch(getTaxEntitiesByContactAction(params.ContactId));

            }).catch((error) => {
                SBNotify({ Msg: "sone error  occured", type: "error" });
            });
        }


    }
    const rowDataUpdated = (params) => {
        params.api.forEachNode((node, index) => {
            if (index === 0) {
                node.setSelected(true);
            }
        });
    }
    const DeleteSelectedAccount = () => {

        // sbaAxios({ url: `${deleteTaxEntityAPI}${deleteAccount.taxEntityID},0` }).then(e => {
        //     SBNotify({ Msg: 'Selected Account Has Been Deleted Successfully' });
        //     setDeleteAccount({taxEntityID:0,contactID:0,DeleteModal:false});
        //     dispatch(getTaxEntitiesByContactAction(params.ContactId));
        // }).then(e => {
        //     console.log("Error Deleting the Account", e);
        //     setDeleteAccount({taxEntityID:0,contactID:0,DeleteModal:false});
        // }
        // );
        setDeleteAccount({ taxEntityID: 0, contactID: 0, DeleteModal: false });
    }

  return (
    <>
          <div className="row m-0" style={{ margintop: "-5px" }}>
              <div className="row-md-12 d-flex gap-2 "style={{ marginBottom: "15px" }}>
                  <div className="col-md-12">
                      
                      <div className="w-100 d-flex justify-content-end">
                          <button type="submit" className="p-sm-btn mx-1" disabled={!isEditable} onClick={() => onAddButtonClick('Account')} ><i className="fa-solid fa-plus" /> Add </button>
                      </div>
                      <div className="px-3">
                          
                              {taxEntityListLoading ? (
                                  <div>
                                      <LoadingScreen />
                                  </div>
                          ) : (

                             <div className="ag-theme-alpine" style={{ height: 350, width: '100%' }}>
                                      <AgGridReact
                                       ref={taxEntityRef}
                                       enableBrowserTooltips={true}
                                       rowSelection={'single'}
                                       columnDefs={ContactColumnDef}
                                       rowData={TaxEntitiesByContact}
                                       defaultColDef={defaultColDef}
                                       onRowClicked={taxEntityGridClick}
                                       onRowDataUpdated={rowDataUpdated}
                                   />
                                  </div> 
                              )}
                         
                  </div>
                  </div>
                
              </div>
              <br></br>
              <div className="row-md-12 d-flex gap-2">
                  <div className="col-md-8">
          {
              TaxEntitiesByContact.length > 0 && (
                  <>
                      {istaxEntityDetailsLoading ? (
                          <><LoadingScreen /></>
                      ) : (
                          <>
                              <div className="p-3">
                                  <AccountDetails details={taxEntityDetails} entityID={taxEntityDetails?.TaxEntityId} />
                              </div>
                          </>
                      )}
                  </>
              )
                  }
                  </div>

                  <div className="col-md-4" style={{ marginTop: "8px" }}>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-between">
                            <label className="fw-medium">Account Roles</label>
                            <button type="submit" className="p-sm-btn mx-1" disabled={!isEditable} onClick={() => onAddButtonClick('Contact')}>
                                <i className="fa-solid fa-plus" /> Add
                            </button>
                        </div>
                        <div className="ag-theme-alpine" style={{ height: 350, width: '100%' }}>
                            <AgGridReact
                                enableBrowserTooltips={true}
                                columnDefs={ContactEntityDef}
                                rowData={taxEntityContacts}
                                defaultColDef={defaultColDef}
                            />
                        </div>
                    </div>
                </div>

              </div>
          </div>
          <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Add Account/Contact'}>
              <div>
                  <div>                     
                      {mode === "Contact" ? (
                          <label className="header-container m-1">
                              <b>Contact</b>
                          </label>
                      ) : (
                          <label className="header-container m-1">
                              <b>Account</b>
                          </label>
                      )}
                      <div>
                          {mode === "Contact" ? (<SBAComboBox
                              className="w-70"
                              textField={"EntityName"}
                              valueField={"EntityId"} 
                              data={Contactlist}
                              onChange={Contactonchange}
                              popupSettings={{ className: 'modalDD' }}
                              value={NewContact}
                              placeholder="--Please select--"
                             
                          />) : (<SBAComboBox
                              className="w-70"
                              textField={"TaxEntityName"}
                              valueField={"TaxEntityId"}
                              data={accountList}
                              onChange={Accountonchange}
                              popupSettings={{ className: 'modalDD' }}
                                  value={NewAccount}
                                  placeholder="--Please select--"
                              
                          />)}
                      </div>

                        <br></br>
                        <label className="header-container m-1">
                            <b>Role</b>
                        </label>
                        <div>
                          <SBAComboBox
                                className="w-70"
                                textField={"ContactRoleName"}
                                valueField={"ContactRoleId"}
                                data={Getcontactroles}
                                onChange={Rolechange}
                                popupSettings={{ className: 'modalDD' }}
                                value={Role}
                                placeholder="--Please select--"

                            />
                        </div>

                        <br></br>
                        {/*<div className="ag-theme-alpine" style={{ height: 350, width: '70%' }}>
                            <AgGridReact
                            enableBrowserTooltips={true}
                                columnDefs={TaxContactdefdataDef}
                                rowData={Accesslist}
                                defaultColDef={defaultColDef}
                                ref={TaxContactAccesseRef}
                                suppressScrollOnNewData={true}
                            />
                         </div> */}
                        <br></br>

                  </div>
                  <div className="mt-4">
                      <button className="s-sm-btn mx-1" onClick={closeModal}>
                          Cancel
                      </button>
                      <button className="p-sm-btn mx-1" onClick={() => mode === "Contact" ? savecontact('Add') : saveAccount()} >
                          Add     
                      </button>
                  </div>
              </div>
          </SBADrawer >
      
          <SBADrawer open={showEdit} setOpen={setshowEdit} close={false} title={'Update Contact'}>
              <div>
                  <div>
                      <label className="header-container m-1">
                          <b>Contact</b>
                      </label>

                        <div>
                          <SBAComboBox
                                className="w-70"
                                textField={"ContactName"}
                                valueField={"ContactId"}
                                data={TaxContactAccessedata}
                                popupSettings={{ className: 'modalDD' }}
                                value={ContactName}
                                disabled
                            />
                        </div>

                        <br></br>
                        <label className="header-container m-1">
                            <b>Role</b>
                        </label>
                        <div>
                          <SBAComboBox
                                className="w-70"
                                textField={"ContactRoleName"}
                                valueField={"ContactRoleId"}
                                data={Getcontactroles}
                                onChange={Rolechange}
                                popupSettings={{ className: 'modalDD' }}
                                value={Role}
                                placeholder="--Please select--"
                            />
                        </div>

                        <br></br>
                        {/* <div className="ag-theme-alpine" style={{ height: 350, width: '70%' }}>
                            <AgGridReact

                                enableBrowserTooltips={true}
                                suppressScrollOnNewData={true}
                                columnDefs={EditTaxContactdefdataDef}
                                rowData={defAccesslist}
                                defaultColDef={defaultColDef}
                                ref={TaxContactAccesseRef}
                            />
                        </div> */}
                        <br></br>

                    </div>
                    <div className="mt-4">
                        <button className="s-sm-btn mx-1" onClick={closeModal}>
                            Cancel
                        </button>
                        <button className="p-sm-btn mx-1" onClick={() => savecontact('Edit')} >
                            Update
                        </button>
                    </div>
                </div>
            </SBADrawer >

            {<Modal show={showModal}  >
                <Modal.Header closeButton onClick={closeModal}>
                    <Modal.Title>Do you want to delete the selected Roles?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>The selected Contact will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={onDeleteButtonClick} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>}
            {<Modal show={deleteAccount.DeleteModal}  >
                <Modal.Header closeButton onClick={() => { setDeleteAccount({ taxEntityID: 0, contactID: 0, DeleteModal: false }) }}>
                    <Modal.Title>Do you want to delete the Selected Account?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>The selected Account will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setDeleteAccount({ taxEntityID: 0, contactID: 0, DeleteModal: false }) }} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={DeleteSelectedAccount} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>}
        </>
    );
};
